import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { FC, useEffect } from 'react'
import { GetGQLTestDataAction } from 'graphql/store'


export const GraphQLTestModulePage: FC = () => {

  const dispatch = useStoreDispatch()
  useEffect(() => {
    dispatch(new GetGQLTestDataAction({ param: 123 }))
  }, [dispatch])

  return (
    <></>
  )
}
